module.exports = __webpack_public_path__ + "img/Reg-emirates.3d6dfde0.svg";